import { ActiveContext } from "shared/ContextSwitcher/store";
import { useIsFeatureEnabled } from "lib/hooks/useIsFeatureEnabled";
import { useListDatasetsQuery } from "lib/types/graphql";
import { isExecutionDisabled } from "lib/datasets/deprecation";

export function useGetIsDatasetIdExecutable(
  activeContext: ActiveContext | undefined
) {
  const isSpellbookContributor = useIsFeatureEnabled(
    "enable-spark-spellbook-contributors"
  );

  const datasetsRes = useListDatasetsQuery();

  return function getIsDatasetIdExecutable(datasetId: number) {
    const dataset = datasetsRes.data?.datasets.find((dataset) => {
      return dataset.id === datasetId;
    });

    return (
      dataset &&
      !isExecutionDisabled(dataset, {
        hasPaidPlan:
          activeContext?.serviceTier.hasPaidPlanSubscription ?? false,
        isSpellbookContributor,
      })
    );
  };
}
